export const lookup: any = {
  get_announcements_error: {
    EN: "Error getting announcements, try again!",
    FR: "Il y a eu une erreur lors de l'obtention des annonces, essayez de nouveau !",
    IT: "Errore durante il recupero degli annunci, riprova!",
  },
  create_announcement: {
    EN: "Successfully created announcement!",
    FR: "Annonce créée avec succès !",
    IT: "Annuncio creato con successo!",
  },
  create_announcement_error: {
    EN: "Error creating announcement, try again!",
    FR: "Il y a eu une erreur lors de la création de l'annonce, essayez de nouveau !",
    IT: "Errore durante la creazione dell'annuncio, riprova!",
  },
  delete_past_announcement: {
    EN: "Unable to delete announcement that has already been sent!",
    FR: "Impossible de supprimer une annonce programmée dans le passé !",
    IT: "Impossibile eliminare l'annuncio che è già stato inviato!",
  },
  enable_announcements: {
    EN: "Announcements have been enabled!",
    FR: "Les annonces ont été activées !",
    IT: "Gli annunci sono stati abilitati!",
  },
  disable_announcements: {
    EN: "Announcements have been disabled!",
    FR: "Les annonces ont été désactivées !",
    IT: "Gli annunci sono stati disabilitati!",
  },
  delete_announcement: {
    EN: "Successfully deleted announcements!",
    FR: "Annonce supprimée avec succès !",
    IT: "Annuncio eliminato con successo!",
  },
  delete_announcement_error: {
    EN: "Error deleting announcement, try again!",
    FR: "Il y a eu une erreur lors de la suppression de l'annonce, essayez de nouveau !",
    IT: "Errore durante l'eliminazione dell'annuncio, riprova!",
  },
  update_announcements_error: {
    EN: "Error updating announcements, try again!",
    FR: "Un problème est survenu lors de la mise à jour des annonces, veuillez réessayer !",
    IT: "Errore durante l'aggiornamento degli annunci, riprova!",
  },
  create_announcement_missing_text: {
    EN: "Must include text in an announcement!",
    FR: "Il faut inclure du texte dans les annonces !",
    IT: "Devi includere del testo in un annuncio!",
  },
  create_announcement_missing_rooms: {
    EN: "There were no rooms selected!",
    FR: "Aucune pièce sélectionnée !",
    IT: "Non sono state selezionate stanze!",
  },
  create_announcement_invalid_schedule: {
    EN: "Invalid schedule chosen!",
    FR: "Le programme choisi est invalide !",
    IT: "Programma non valido selezionato!",
  },
  create_announcement_invalid_type: {
    EN: "Invalid type chosen!",
    FR: "Le type choisi est invalide !",
    IT: "Tipo non valido selezionato!",
  },
  create_announcement_invalid_schedule_type: {
    EN: "Invalid schedule type chosen!",
    FR: "Le type de programme choisi est invalide !",
    IT: "Tipo di programma non valido selezionato!",
  },
  create_announcement_invalid_schedule_params_every: {
    EN: "Invalid value chosen for interval period!",
    FR: "Les valeurs choisies pour cet intervalle sont invalides !",
    IT: "Valore non valido selezionato per il periodo dell'intervallo!",
  },
  create_announcement_invalid_schedule_params_int_period: {
    EN: "Invalid value chosen for interval period!",
    FR: "Les valeurs choisies pour cet intervalle sont invalides !",
    IT: "Valore non valido selezionato per il periodo dell'intervallo!",
  },
  create_announcement_invalid_schedule_params_prd_period: {
    EN: "Invalid value chosen for periodic period!",
    FR: "Les valeurs choisies pour la durée périodique sont invalides !",
    IT: "Valore non valido selezionato per il periodo periodico!",
  },
  create_announcement_invalid_schedule_dow: {
    EN: "Invalid values chosen for days of the week!",
    FR: "Les valeurs choisies pour les jours de la semaine sont invalides !",
    IT: "Valori non validi selezionati per i giorni della settimana!",
  },
  create_announcement_invalid_schedule_dom: {
    EN: "Invalid values chosen for days of the month!",
    FR: "Les valeurs choisies pour les jours du mois sont invalides !",
    IT: "Valori non validi selezionati per i giorni del mese!",
  },
  create_announcement_invalid_date: {
    EN: "Must schedule announcement for a future date!",
    FR: "Il faut planifier les événements pour une date postérieure !",
    IT: "Devi pianificare l'annuncio per una data futura!",
  },
  login: {
    EN: "Welcome back to audico!",
    FR: "Bienvenue sur audico !",
    IT: "Benvenuto su audico!",
  },
  login_error: {
    EN: "Incorrect credentials!",
    FR: "Identifiants non valides !",
    IT: "Credenziali non valide!",
  },
  logout: {
    EN: "Logged out!",
    FR: "Déconnecté!",
    IT: "Disconnesso!",
  },
  logout_error: {
    EN: "Error logging out!",
    FR: "Erreur de déconnexion !",
    IT: "Errore durante la disconnessione!",
  },
  update_password: {
    EN: "Successfully updated password!",
    FR: "Mot de passe mis à jour avec succès !",
    IT: "Password aggiornata con successo!",
  },
  update_password_error: {
    EN: "Incorrect credentials!",
    FR: "Identifiants non valides !",
    IT: "Credenziali non valide!",
  },
  update_password_duplicate: {
    EN: "New password must not match current password!",
    FR: "Le nouveau mot de passe ne doit pas correspondre à l'ancien !",
    IT: "La nuova password non deve corrispondere alla password corrente!",
  },
  update_password_no_match: {
    EN: "New passwords do not match!",
    FR: "Les nouveaux mots de passes ne correspondent pas !",
    IT: "Le nuove password non corrispondono!",
  },
  update_language_error: {
    EN: "Error updating language!",
    FR: "Erreur lors de la mise à jour de la langue !",
    IT: "Errore durante l'aggiornamento della lingua!",
  },
  update_device: {
    EN: "Successfully updated device!",
    FR: "Appareil mis à jour avec succès !",
    IT: "Dispositivo aggiornato con successo!",
  },
  update_device_error: {
    EN: "Error updating device, try again!",
    FR: "Erreur lors de la mise à jour de l'appareil, réessayez !",
    IT: "Errore durante l'aggiornamento del dispositivo, riprova!",
  },
  get_events_error: {
    EN: "Error getting events, try again!",
    FR: "Erreur lors de l'obtention des événements, essayez de nouveau !",
    IT: "Errore durante il recupero degli eventi, riprova!",
  },
  create_event: {
    EN: "Successfully created event!",
    FR: "Événement créé avec succès !",
    IT: "Evento creato con successo!",
  },
  create_event_error: {
    EN: "Error creating event, try again!",
    FR: "Erreur lors de la création de l'événement, essayez de nouveau !",
    IT: "Errore durante la creazione dell'evento, riprova!",
  },
  delete_event_in_progress: {
    EN: "Unable to delete event that is in progress!",
    FR: "Impossible de supprimer un événement en cours !",
    IT: "Impossibile eliminare l'evento in corso!",
  },
  delete_event: {
    EN: "Successfully deleted event!",
    FR: "Événement supprimé avec succès !",
    IT: "Evento eliminato con successo!",
  },
  delete_event_error: {
    EN: "Error deleting event, try again!",
    FR: "Erreur lors de la suppression de l'événement, essayez de nouveau !",
    IT: "Errore durante l'eliminazione dell'evento, riprova!",
  },
  warning_event_no_name: {
    EN: "Must include a name for an event!",
    FR: "Il faut donner un nom à l'événement !",
    IT: "Devi includere un nome per un evento!",
  },
  warning_event_datetimes_past: {
    EN: "Datetime end must be after current datetime!",
    FR: "La date de fin doit être postérieure à la date actuelle !",
    IT: "La data di fine deve essere successiva alla data corrente!",
  },
  warning_event_end_before_start: {
    EN: "Datetime end must be after start datetime!",
    FR: "La date de fin doit être postérieure à la date de début !",
    IT: "La data di fine deve essere successiva alla data di inizio!",
  },
  undo_activity_log_unauthorised: {
    EN: "Unauthorised to undo activities!",
    FR: "Autorisation requise pour défaire les activités !",
    IT: "Non autorizzato a annullare le attività!",
  },
  undo_activity_log: {
    EN: "Activity undone successfully!",
    FR: "Activité supprimée avec succès !",
    IT: "Attività annullata con successo!",
  },
  undo_activity_log_error: {
    EN: "Error undoing activity!",
    FR: "Erreur lors de la suppression de l'activité !",
    IT: "Errore durante l'annullamento dell'attività!",
  },
  create_request_option_template: {
    EN: "Successfully created template!",
    FR: "Modèle créé avec succès !",
    IT: "Modello creato con successo!",
  },
  create_request_option_template_error: {
    EN: "Error creating template, try again!",
    FR: "Erreur lors de la création du modèle, réessayez !",
    IT: "Errore durante la creazione del modello, riprova!",
  },
  update_request_option_template: {
    EN: "Successfully updated template!",
    FR: "Modèle mis à jour avec succès !",
    IT: "Modello aggiornato con successo!",
  },
  update_request_option_template_error: {
    EN: "Error updating template, try again!",
    FR: "Erreur lors de la mise à jour du modèle, réessayez !",
    IT: "Errore durante l'aggiornamento del modello, riprova!",
  },
  delete_request_option_template: {
    EN: "Successfully deleted template!",
    FR: "Modèle supprimé avec succès !",
    IT: "Modello eliminato con successo!",
  },
  delete_request_option_template_error: {
    EN: "Error deleting template, try again!",
    FR: "Erreur lors de la suppression du modèle, veuillez réessayer !",
    IT: "Errore durante l'eliminazione del modello, riprova!",
  },
  update_request_status_complete: {
    EN: "Request marked as Complete!",
    FR: "Statut de la requête mis à jour pour Complété !",
    IT: "Richiesta contrassegnata come completata!",
  },
  update_request_status_in_progress: {
    EN: "Request marked as In Progress!",
    FR: "Statut de la requête mis à jour pour En Cours !",
    IT: "Richiesta contrassegnata come in corso!",
  },
  update_request_status_error: {
    EN: "Error updating request!",
    FR: "Erreur lors de la mise à jour du statut de la requête !",
    IT: "Errore durante l'aggiornamento della richiesta!",
  },
  create_service: {
    EN: "Service created!",
    FR: "Service créé!",
    IT: "Servizio creato!",
  },
  create_service_error: {
    EN: "Error creating service!",
    FR: "Erreur lors de la création du service !",
    IT: "Errore durante la creazione del servizio!",
  },
  create_service_error_already_exists: {
    EN: "Service already exists, please update the existing one or delete it!",
    FR: "Ce service existe déjà, veuillez le mettre à jour ou supprimer celui existant !",
    IT: "Il servizio esiste già, aggiorna quello esistente o eliminane uno!",
  },
  delete_service: {
    EN: "Service deleted!",
    FR: "Service supprimé !",
    IT: "Servizio eliminato!",
  },
  delete_service_error: {
    EN: "Error deleting service!",
    FR: "Erreur lors de la suppression du service !",
    IT: "Errore durante l'eliminazione del servizio!",
  },
  update_service: {
    EN: "Service updated!",
    FR: "Service mis à jour !",
    IT: "Servizio aggiornato!",
  },
  update_service_error: {
    EN: "Error updating service!",
    FR: "Erreur lors de la mise à jour du service !",
    IT: "Errore durante l'aggiornamento del servizio!",
  },
  warning_service_end_before_start: {
    EN: "Service end time must be after start time!",
    FR: "L'heure de fin du service doit être postérieure à l'heure de début !",
    IT: "L'ora di fine del servizio deve essere successiva all'ora di inizio!",
  },
  create_menu: {
    EN: "Menu created!",
    FR: "Menu créé !",
    IT: "Menu creato!",
  },
  create_menu_error: {
    EN: "Error creating menu!",
    FR: "Erreur lors de la création du menu !",
    IT: "Errore durante la creazione del menu!",
  },
  create_menu_error_already_exists: {
    EN: "Menu already exists, please update the existing one or delete it!",
    FR: "Ce menu existe déjà, veuillez le mettre à jour ou supprimer celui existant !",
    IT: "Il menu esiste già, aggiorna quello esistente o eliminane uno!",
  },
  delete_menu: {
    EN: "Menu deleted!",
    FR: "Menu supprimé !",
    IT: "Menu eliminato!",
  },
  delete_menu_error: {
    EN: "Error deleting menu!",
    FR: "Erreur lors de la suppression du menu !",
    IT: "Errore durante l'eliminazione del menu!",
  },
  update_menu: {
    EN: "Menu updated!",
    FR: "Menu mis à jour !",
    IT: "Menu aggiornato!",
  },
  update_menu_error: {
    EN: "Error updating menu!",
    FR: "Erreur lors de la mise à jour du menu !",
    IT: "Errore durante l'aggiornamento del menu!",
  },
  warning_menu_end_before_start: {
    EN: "Menu end datetime must be after start datetime!",
    FR: "La date de fin du menu doit être postérieure à la date de début !",
    IT: "La data di fine del menu deve essere successiva alla data di inizio!",
  },
  update_status_request_options: {
    EN: "Status of request options successfully updated!",
    FR: "Le statut des options de requête a été mis à jour avec succès !",
    IT: "Lo stato delle opzioni di richiesta è stato aggiornato con successo!",
  },
  update_status_request_options_error: {
    EN: "Error updating status of requests!",
    FR: "Erreur lors de la mise à jour du statut des requêtes !",
    IT: "Errore durante l'aggiornamento dello stato delle richieste!",
  },
  must_provide_request_options_in_template: {
    EN: "Please provide some request options within this template!",
    FR: "Veuillez fournir des options de requête au sein de ce modèle !",
    IT: "Fornisci alcune opzioni di richiesta in questo modello!",
  },
  create_poi: {
    EN: "Successfully created point of interest!",
    FR: "Centre d'intérêt créé avec succès !",
    IT: "Punto di interesse creato con successo!",
  },
  create_poi_error: {
    EN: "Error when creating a point of interest!",
    FR: "Une erreur est survenue lors de la création du centre d'intérêt !",
    IT: "Errore durante la creazione di un punto di interesse!",
  },
  create_poi_error_no_times: {
    EN: "Enter valid start and end times for point of interest!",
    FR: "Veuillez entrer des heures de début et de fin valides !",
    IT: "Inserisci orari di inizio e fine validi per il punto di interesse!",
  },
  update_poi: {
    EN: "Successfully updated point of interest!",
    FR: "Centre d'intérêt mis à jour avec succès !",
    IT: "Punto di interesse aggiornato con successo!",
  },
  update_poi_error: {
    EN: "Error when updating a point of interest!",
    FR: "Une erreur est survenue lors de la mise à jour du centre d'intérêt !",
    IT: "Errore durante l'aggiornamento di un punto di interesse!",
  },
  delete_poi: {
    EN: "Successfully deleted point of interest!",
    FR: "Centre d'intérêt supprimé avec succès !",
    IT: "Punto di interesse eliminato con successo!",
  },
  delete_poi_error: {
    EN: "Error when deleting a point of interest!",
    FR: "Une erreur est survenue lors de la suppression du centre d'intérêt !",
    IT: "Errore durante l'eliminazione di un punto di interesse!",
  },
  create_direction: {
    EN: "Successfully created direction!",
    FR: "Les directions ont bien été créées!",
    IT: "Direzione creata con successo!",
  },
  create_direction_error: {
    EN: "Error when creating direction!",
    FR: "Une erreur est survenue lors de la création des directions !",
    IT: "Errore durante la creazione della direzione!",
  },
  update_direction: {
    EN: "Successfully updated direction!",
    FR: "Directions mises à jour avec succès !",
    IT: "Direzione aggiornata con successo!",
  },
  update_direction_error: {
    EN: "Error when updating direction!",
    FR: "Une erreur est survenue lors de la mise à jour des directions !",
    IT: "Errore durante l'aggiornamento della direzione!",
  },
  delete_direction: {
    EN: "Successfully deleted direction!",
    FR: "Directions supprimées avec succès !",
    IT: "Direzione eliminata con successo!",
  },
  delete_direction_error: {
    EN: "Error when deleting direction!",
    FR: "Une erreur est survenue lors de la suppression des directions !",
    IT: "Errore durante l'eliminazione della direzione!",
  },
  create_webhook: {
    EN: "Webhook created!",
    FR: "Point d'ancrage web créé avec succès !",
    IT: "Webhook creato con successo!",
  },
  create_webhook_error: {
    EN: "Error creating webhook!",
    FR: "Une erreur est survenue lors de la création du point d'ancrage web !",
    IT: "Errore durante la creazione del webhook!",
  },
  delete_webhook: {
    EN: "Webhook deleted!",
    FR: "Point d'ancrage web supprimé !",
    IT: "Webhook eliminato!",
  },
  delete_webhook_error: {
    EN: "Error deleting webhook!",
    FR: "Une erreur est survenue lors de la suppression du point d'ancrage web !",
    IT: "Errore durante l'eliminazione del webhook!",
  },
  update_webhook: {
    EN: "Webhook updated!",
    FR: "Point d'ancrage web mis à jour !",
    IT: "Webhook aggiornato!",
  },
  update_webhook_error: {
    EN: "Error updating webhook!",
    FR: "Une erreur est survenue lors de la mise à jour du point d'ancrage web !",
    IT: "Errore durante l'aggiornamento del webhook!",
  },
  placeholder_url_depth_too_large: {
    EN: "URL placeholder depth cannot be more than 1!",
    FR: "La profondeur du texte de remplissage de l'URL ne peut pas être supérieure à 1 !",
    IT: "La profondità del segnaposto URL non può essere superiore a 1!",
  },
  placeholder_body_depth_too_large: {
    EN: "Body placeholder depth cannot be more than 2!",
    FR: "La profondeur du texte de remplissage du corps ne peut pas être supérieure à 2 !",
    IT: "La profondità del segnaposto del corpo non può essere superiore a 2!",
  },
  services_STD_start_after_end: {
    EN: "Start time must be after end time!",
    FR: "L'heure de début doit être postérieure à l'heure de fin !",
    IT: "L'ora di inizio deve essere successiva all'ora di fine!",
  },
  update_room: {
    EN: "Room successfully updated!",
    FR: "La pièce a bien été mise à jour !",
    IT: "Stanza aggiornata con successo!",
  },
  create_room: {
    EN: "Room successfully created!",
    FR: "La pièce a été créée avec succès !",
    IT: "Stanza creata con successo!",
  },
  delete_room: {
    EN: "Room successfully deleted!",
    FR: "La pièce a été supprimée avec succès !",
    IT: "Stanza eliminata con successo!",
  },
  room_error: {
    EN: "Error with room!",
    FR: "Une erreur est survenue avec la pièce !",
    IT: "Errore con la stanza!",
  },
  disassociate_device_from_room: {
    EN: "Successfully disassociated devices from rooms!",
    FR: "Les appareils ont bien été dissociés des pièce !",
    IT: "Disassocia i dispositivi dalle stanze con successo!",
  },
  disassociate_device_from_room_warning: {
    EN: "Disassociated some devices from their rooms!",
    FR: "Certains appareils ont été dissociés de leurs pièces !",
    IT: "Disassociati alcuni dispositivi dalle loro stanze!",
  },
  disassociate_device_from_room_none: {
    EN: "Unable to disassociate any devices from their rooms!",
    FR: "Impossible de dissocier les appareils de leurs pièces !",
    IT: "Impossibile disassociare i dispositivi dalle loro stanze!",
  },
  disassociate_device_from_room_error: {
    EN: "Error when disassociating devices from rooms!",
    FR: "Une erreur est survenue lors de la dissociation des appareils !",
    IT: "Errore durante la disassociazione dei dispositivi dalle stanze!",
  },
  create_template_campaign: {
    EN: "Successfully created dynamic template campaign!",
    FR: "Les campagnes dynamiques a été créée avec succès !",
    IT: "Campagna modello dinamica creata con successo!",
  },
  create_template_campaign_error: {
    EN: "Error when creating dynamic template campaign!",
    FR: "Une erreur est survenue lors de la création d'une campagne dynamiques !",
    IT: "Errore durante la creazione di una campagna modello dinamica!",
  },
  create_pinned_campaign: {
    EN: "Successfully created pinned campaign!",
    FR: "Une campagne épinglée a été créée avec succès !",
    IT: "Campagna bloccata creata con successo!",
  },
  create_rotating_campaign: {
    EN: "Successfully created rotating campaign!",
    FR: "Une campagne en rotation a été créée avec succès !",
    IT: "Campagna rotante creata con successo!",
  },
  create_pinned_campaign_error: {
    EN: "Error when creating pinned campaign!",
    FR: "Une erreur est survenue lors de la création d'une campagne épinglée !",
    IT: "Errore durante la creazione di una campagna bloccata!",
  },
  create_rotating_campaign_error: {
    EN: "Error when creating rotating campaign!",
    FR: "Une erreur est survenue lors de la création d'une campagne en rotation !",
    IT: "Errore durante la creazione di una campagna rotante!",
  },
  delete_campaign: {
    EN: "Successfully deleted campaign!",
    FR: "La campagne a été supprimée avec succès !",
    IT: "Campagna eliminata con successo!",
  },
  delete_campaign_error: {
    EN: "Error when deleting campaign!",
    FR: "Une erreur est survenue lors de la suppression d'une campagne !",
    IT: "Errore durante l'eliminazione della campagna!",
  },
  create_campaign_missing_rooms: {
    EN: "There were no rooms selected!",
    FR: "Aucune pièce sélectionnée !",
    IT: "Non sono state selezionate stanze!",
  },
  create_campaign_invalid_date: {
    EN: "Must schedule campaign for a future date!",
    FR: "Vous devez sélectionner la campagne pour une date ultérieure !",
    IT: "Devi pianificare la campagna per una data futura!",
  },
  create_campaign_start_after_end_date: {
    EN: "Must schedule campaign with start date before end date!",
    FR: "Vous devez programmer la campagne avec une date de début avant la date de fin !",
    IT: "Devi pianificare la campagna con data di inizio prima della data di fine!",
  },
  create_campaign_dynamic_no_bg: {
    EN: "Must choose at least 1 background image for dynamic campaigns!",
    FR: "Vous devez choisir au moins une image de fond pour les campagnes dynamiques !",
    IT: "Devi scegliere almeno 1 immagine di sfondo per le campagne dinamiche!",
  },
  create_campaign_missing_days: {
    EN: "There were no days selected!",
    FR: "Aucune jour sélectionnée !",
    IT: "Non sono stati selezionati giorni!",
  },
  create_event_missing_rooms: {
    EN: "There were no rooms selected!",
    FR: "Aucune pièce sélectionnée !",
    IT: "Non sono state selezionate stanze!",
  },
  create_contact_book: {
    EN: "Contact book successfully created!",
    FR: "Carnet d'adresses créé avec succès !",
    IT: "Rubrica creata con successo!",
  },
  create_contact_book_error: {
    EN: "Unable to create contact book, try again!",
    FR: "Le carnet d'adresses n'a pas pu être créé, veuillez réessayer !",
    IT: "Impossibile creare la rubrica, riprova!",
  },
  update_contact_book: {
    EN: "Contact book successfully updated!",
    FR: "Le carnet d'adresses a bien été mis à jour !",
    IT: "Rubrica aggiornata con successo!",
  },
  update_contact_book_error: {
    EN: "Unable to update contact book, try again!",
    FR: "Impossible de mettre à jour le carnet d'adresses, veuillez réessayer !",
    IT: "Impossibile aggiornare la rubrica, riprova!",
  },
  delete_contact_book: {
    EN: "Contact book successfully deleted!",
    FR: "Carnet d'adresses supprimé avec succès !",
    IT: "Rubrica eliminata con successo!",
  },
  delete_contact_book_error: {
    EN: "Unable to delete address book, try again!",
    FR: "Impossible de supprimer le carnet d'adresses, veuillez réessayer !",
    IT: "Impossibile eliminare la rubrica, riprova!",
  },
  associate_contact_book_to_rooms: {
    EN: "Address book successfully associated to rooms!",
    FR: "Le carnet d'adresses a bien été associé aux pièces correspondantes !",
    IT: "Rubrica associata con successo alle stanze!",
  },
  associate_contact_book_to_rooms_error: {
    EN: "Unable to associate address book to rooms, try again!",
    FR: "Impossible d'associer le carnet d'adresses aux pièces, veuillez réessayer !",
    IT: "Impossibile associare la rubrica alle stanze, riprova!",
  },
  remove_contact_book_from_rooms: {
    EN: "Address book successfully removed from rooms!",
    FR: "Le carnet d'adresses a bien été supprimé des pièces correspondantes !",
    IT: "Rubrica rimossa con successo dalle stanze!",
  },
  remove_contact_book_from_rooms_error: {
    EN: "Unable to remove address book from rooms, try again!",
    FR: "Impossible de supprimer le carnet d'adresses des pièces correspondantes, veuillez réessayer !",
    IT: "Impossibile rimuovere la rubrica dalle stanze, riprova!",
  },
  create_reciprocal_association: {
    EN: "Reciprocal association created!",
    FR: "Association réciproque créée !",
    IT: "Associazione reciproca creata!",
  },
  create_reciprocal_association_error: {
    EN: "Unable to create reciprocal association, try again!",
    FR: "Impossible de créer une association réciproque, veuillez réessayer !",
    IT: "Impossibile creare un'associazione reciproca, riprova!",
  },
  remove_reciprocal_association: {
    EN: "Reciprocal association removed!",
    FR: "Association réciproque retirée !",
    IT: "Associazione reciproca rimossa!",
  },
  remove_reciprocal_association_error: {
    EN: "Unable to remove reciprocal association, try again!",
    FR: "Impossible de retirer une association réciproque, veuillez réessayer !",
    IT: "Impossibile rimuovere un'associazione reciproca, riprova!",
  },
  reached_max_contacts_contact_book: {
    EN: "You cannot have more than 10 contacts in an address book!",
    FR: "Il ne peut pas y avoir plus de 10 contacts dans un carnet d'adresses !",
    IT: "Non puoi avere più di 10 contatti in una rubrica!",
  },
  invalid_room_contact: {
    EN: "You must select a room if the contact type is a room!",
    FR: "Vous devez sélectionner une pièce si le type de contact est une pièce !",
    IT: "Devi selezionare una stanza se il tipo di contatto è una stanza!",
  },
  contact_book_name_too_long: {
    EN: "Address book name must be less than 50 characters!",
    FR: "Le nom du carnet d'adresses doit contenir moins de 50 caractères !",
    IT: "Il nome della rubrica deve contenere meno di 50 caratteri!",
  },
  invalid_contact_type: {
    EN: "Contact type must be a room or phone number!",
    FR: "Le type de contact doit être une pièce ou un numéro de téléphone !",
    IT: "Il tipo di contatto deve essere una stanza o un numero di telefono!",
  },
  too_many_phone_numbers: {
    EN: "Up to 3 phone numbers can be provided for a contact, you provided too many!",
    FR: "Un maximum de 3 numéros de téléphone peuvent être associés à un contact, vous en avez associé de trop !",
    IT: "Fino a 3 numeri di telefono possono essere forniti per un contatto, ne hai forniti troppi!",
  },
  phone_numbers_dont_match_e164: {
    EN: "Ensure that phone numbers include a country code at the start followed by the subscriber number!",
    FR: "Veuillez vous assurer que les numéros de téléphone incluent l'indicatif du pays suivi du numéro du correspondant !",
    IT: "Assicurati che i numeri di telefono includano un prefisso internazionale seguito dal numero di abbonato!",
  },
  update_waiting_error: {
    EN: "I don't recognise the waiting status, try again!",
    FR: "Je ne reconnais pas le statut d'attente, veuillez réessayer !",
    IT: "Non riconosco lo stato di attesa, riprova!",
  },
  missing_times: {
    EN: "There are times missing!",
    FR: "Aucun heure sélectionnée !",
    IT: "Non ci sono orari selezionati!",
  },
  missing_schedule: {
    EN: "There is no schedule selected!",
    FR: "Aucun programme sélectionnée !",
    IT: "Non è stato selezionato alcun programma!",
  },
  update_event: {
    EN: "Successfully updated event!",
    FR: "Événement mis à jour avec succès !",
    IT: "Evento aggiornato con successo!",
  },
  update_event_error: {
    EN: "Error updating event, try again!",
    FR: "Impossible de mettre à jour de l'événement, veuillez réessayer !",
    IT: "Impossibile aggiornare l'evento, riprova!",
  },
  create_trivia: {
    EN: "Trivia created!",
    FR: "Anecdotes créé !",
    IT: "Aneddoti creati!",
  },
  create_trivia_error: {
    EN: "Error creating trivia!",
    FR: "Erreur lors de la création du anecdotes !",
    IT: "Errore durante la creazione di aneddoti!",
  },
  update_trivia: {
    EN: "Trivia successfully updated!",
    FR: "Anecdotes a bien été mis à jour !",
    IT: "Aneddoti aggiornati con successo!",
  },
  update_trivia_error: {
    EN: "Unable to update trivia, try again!",
    FR: "Impossible de mettre à jour les futilités, veuillez réessayer !",
    IT: "Impossibile aggiornare gli aneddoti, riprova!",
  },
  delete_trivia: {
    EN: "Trivia successfully deleted!",
    FR: "Anecdotes supprimé avec succès !",
    IT: "Aneddoti eliminati con successo!",
  },
  delete_trivia_error: {
    EN: "Unable to delete trivia, try again!",
    FR: "Impossible de supprimer les futilités, veuillez réessayer !",
    IT: "Impossibile eliminare gli aneddoti, riprova!",
  },
  create_photo_album: {
    EN: "Photo album created!",
    FR: "Album photo créé !",
    IT: "Album fotografico creato!",
  },
  create_photo_album_error: {
    EN: "Error creating photo album!",
    FR: "Erreur lors de la création du album photo !",
    IT: "Errore durante la creazione dell'album fotografico!",
  },
  update_photo_album: {
    EN: "Photo album updated!",
    FR: "Album photo mis à jour !",
    IT: "Album fotografico aggiornato!",
  },
  update_photo_album_error: {
    EN: "Error updating photo album!",
    FR: "Impossible de mettre à jour la album photo !",
    IT: "Impossibile aggiornare l'album fotografico!",
  },
  delete_photo_album: {
    EN: "Photo album successfully deleted!",
    FR: "Album photo supprimée avec succès !",
    IT: "Album fotografico eliminato con successo!",
  },
  delete_photo_album_error: {
    EN: "Unable to delete photo album, try again!",
    FR: "Impossible de supprimer le album photo, veuillez réessayer !",
    IT: "Impossibile eliminare l'album fotografico, riprova!",
  },
  upload_photos: {
    EN: "Photos successfully uploaded!",
    FR: "Photos téléchargées avec succès !",
    IT: "Foto caricate con successo!",
  },
  upload_photos_error: {
    EN: "Error uploading photos!",
    FR: "Erreur lors du téléchargement des photos !",
    IT: "Errore durante il caricamento delle foto!",
  },
  delete_photos: {
    EN: "Photos successfully deleted!",
    FR: "Photos supprimée avec succès !",
    IT: "Foto eliminate con successo!",
  },
  delete_photos_error: {
    EN: "Unable to delete photos, try again!",
    FR: "Impossible de supprimer les photos, veuillez réessayer !",
    IT: "Impossibile eliminare le foto, riprova!",
  },
  delete_photo_albums: {
    EN: "Photo albums successfully deleted!",
    FR: "Album photos supprimée avec succès !",
    IT: "Album fotografici eliminati con successo!",
  },
  delete_photo_albums_error: {
    EN: "Unable to delete photo albums, try again!",
    FR: "Impossible de supprimer les album photos, veuillez réessayer !",
    IT: "Impossibile eliminare gli album fotografici, riprova!",
  },
  process_photo_error: {
    EN: "Error when processing photo, try again!",
    FR: "Erreur lors du traitement des photos, réessayez !",
    IT: "Errore durante l'elaborazione della foto, riprova!",
  },
  remove_photo: {
    EN: "Photo removed from album!",
    FR: "Photo supprimée de l'album !",
    IT: "Foto rimossa dall'album!",
  },
  remove_photo_error: {
    EN: "Error when removing photo from album!",
    FR: "Erreur lors de la suppression de la photo de l'album !",
    IT: "Errore durante la rimozione della foto dall'album!",
  },
  max_photos_reached: {
    EN: "You've exceeded the maximum number of uploaded photos!",
    FR: "Le nombre maximum de photos téléchargées a été atteint !",
    IT: "Hai superato il numero massimo di foto caricate!",
  },
  max_files_reached: {
    EN: "You've exceeded the maximum number of uploaded files!",
    FR: "Le nombre maximum des dossiers téléchargées a été atteint !",
    IT: "Hai superato il numero massimo di file caricati!",
  },
  mapping_must_be_unique: {
    EN: "Invalid choices for the mapping!",
    FR: "Choix invalides pour le mappage !",
    IT: "Scelte non valide per il mapping!",
  },
  pdf_extraction_no_text_selected: {
    EN: "Select some text to extract!",
    FR: "Sélectionnez du texte à extraire !",
    IT: "Seleziona del testo da estrarre!",
  },
  pdf_extraction_success: {
    EN: "Successfully extracted text!",
    FR: "Texte extrait avec succès !",
    IT: "Testo estratto con successo!",
  },
  create_newsletter: {
    EN: "Successfully created newsletter!",
    FR: "Newsletter créée avec succès !",
    IT: "Newsletter creata con successo!",
  },
  create_newsletter_error: {
    EN: "Error when creating newsletter!",
    FR: "Erreur lors de la création de la newsletter !",
    IT: "Errore durante la creazione della newsletter!",
  },
  update_newsletter: {
    EN: "Successfully updated newsletter!",
    FR: "Newsletter mise à jour avec succès !",
    IT: "Newsletter aggiornata con successo!",
  },
  update_newsletter_error: {
    EN: "Error when updating newsletter!",
    FR: "Erreur lors de la mise à jour de la newsletter !",
    IT: "Errore durante l'aggiornamento della newsletter!",
  },
  delete_newsletter: {
    EN: "Successfully deleted newsletter!",
    FR: "Newsletter supprimée avec succès !",
    IT: "Newsletter eliminata con successo!",
  },
  delete_newsletter_error: {
    EN: "Error when deleting newsletter!",
    FR: "Erreur lors de la suppression de la newsletter !",
    IT: "Errore durante l'eliminazione della newsletter!",
  },
  update_catalog: {
    EN: "Successfully updated catalog!",
    FR: "Catalogue mise à jour avec succès !",
    IT: "Catalogo aggiornato con successo!",
  },
  update_catalog_error: {
    EN: "Error when updating catalog!",
    FR: "Erreur lors de la mise à jour de la catalogue !",
    IT: "Errore durante l'aggiornamento del catalogo!",
  },
  create_payment_item: {
    EN: "Successfully created payment item!",
    FR: "Élément de paiement créé avec succès !",
    IT: "Elemento di pagamento creato con successo!",
  },
  create_payment_item_error: {
    EN: "Error when creating payment item!",
    FR: "Erreur lors de la création de l'objet de paiement !",
    IT: "Errore durante la creazione dell'elemento di pagamento!",
  },
  update_payment_item: {
    EN: "Successfully updated payment item!",
    FR: "Élément de paiement mis à jour avec succès !",
    IT: "Elemento di pagamento aggiornato con successo!",
  },
  update_payment_item_error: {
    EN: "Error when updating payment item!",
    FR: "Erreur lors de la mise à jour de l'élément de paiement !",
    IT: "Errore durante l'aggiornamento dell'elemento di pagamento!",
  },
  delete_payment_item: {
    EN: "Successfully deleted payment item!",
    FR: "Élément de paiement supprimé avec succès !",
    IT: "Elemento di pagamento eliminato con successo!",
  },
  delete_payment_item_error: {
    EN: "Error when deleting payment item!",
    FR: "Erreur lors de la suppression de l'élément de paiement !",
    IT: "Errore durante l'eliminazione dell'elemento di pagamento!",
  },
  no_request_option: {
    EN: "Please select a request option!",
    FR: "Veuillez sélectionner une option de demande !",
    IT: "Seleziona un'opzione di richiesta!",
  },
  missing_dates: {
    EN: "You are missing some dates in the input form!",
    FR: "Il manque des dates dans le formulaire de saisie !",
    IT: "Manca qualche data nel modulo di input!",
  },
  not_complete: {
    EN: "The form is not complete!",
    FR: "Le formulaire n'est pas complet !",
    IT: "Il modulo non è completo!",
  },
  start_date_not_before_end: {
    EN: "The end date & time must be after the start date & time!",
    FR: "La date et l'heure de fin doivent être postérieures à la date et à l'heure de début !",
    IT: "La data e l'ora di fine devono essere successive alla data e all'ora di inizio!",
  },
  start_time_not_before_end: {
    EN: "The end time must be after the start time!",
    FR: "La date et l'heure de fin doivent être postérieures à la date et à l'heure de début !",
    IT: "L'ora di fine deve essere successiva all'ora di inizio!",
  },
  forgot_appliance: {
    EN: "The appliance has been forgotten!",
    FR: "L'appareil a été oublié !",
    IT: "L'elettrodomestico è stato dimenticato!",
  },
  appliance_toggle_power: {
    EN: "Appliance power toggled!",
    FR: "L'alimentation de l'appareil a été activée/désactivée !",
    IT: "L'alimentazione dell'elettrodomestico è stata attivata/disattivata!",
  },
  update_smart_control_group: {
    EN: "Smart control group updated!",
    FR: "Le groupe de contrôle intelligent a été mis à jour !",
    IT: "Gruppo di controllo intelligente aggiornato!",
  },
  create_smart_control_group: {
    EN: "Smart control group created!",
    FR: "Le groupe de contrôle intelligent a été créé !",
    IT: "Gruppo di controllo intelligente creato!",
  },
  delete_smart_control_group: {
    EN: "Smart control group deleted!",
    FR: "Le groupe de contrôle intelligent a été supprimé !",
    IT: "Gruppo di controllo intelligente eliminato!",
  },
  create_survey: {
    EN: "Survey created!",
    FR: "Le sondage a été créé !",
    IT: "Sondaggio creato!",
  },
  create_survey_error: {
    EN: "Error when creating survey!",
    FR: "Erreur lors de la création du sondage !",
    IT: "Errore durante la creazione del sondaggio!",
  },
  update_survey: {
    EN: "Survey updated!",
    FR: "Le sondage a été mis à jour !",
    IT: "Sondaggio aggiornato!",
  },
  update_survey_error: {
    EN: "Error when updating survey!",
    FR: "Erreur lors de la mise à jour du sondage !",
    IT: "Errore durante l'aggiornamento del sondaggio!",
  },
  delete_survey: {
    EN: "Survey deleted!",
    FR: "Le sondage a été supprimé !",
    IT: "Sondaggio eliminato!",
  },
  fill_required_fields: {
    EN: "Please fill in all required fields!",
    FR: "Veuillez remplir tous les champs obligatoires !",
    IT: "Si prega di compilare tutti i campi obbligatori!",
  },
  survey_multiple_choice_missing_answer: {
    EN: "You provided an empty answer!",
    FR: "Vous avez fourni une réponse vide !",
    IT: "Hai fornito una risposta vuota!",
  },
  survey_multiple_choice_missing_answers: {
    EN: "You must provide at least 2 answers for a multiple choice question!",
    FR: "Vous devez fournir au moins 2 réponses pour une question à choix multiples !",
    IT: "Devi fornire almeno 2 risposte per una domanda a scelta multipla!",
  },
  survey_multiple_choice_incorrect_answer: {
    EN: "You must select a valid answer to be correct for a multiple choice question!",
    FR: "Vous devez sélectionner une réponse valide pour qu'elle soit correcte pour une question à choix multiples !",
    IT: "Devi selezionare una risposta valida per essere corretta per una domanda a scelta multipla!",
  },
  survey_multiple_choice_missing_question: {
    EN: "You provided an empty question!",
    FR: "Vous avez fourni une question vide !",
    IT: "Hai fornito una domanda vuota!",
  },
  create_weblink: {
    EN: "Weblink created!",
    FR: "Le lien web a été créé !",
    IT: "Collegamento web creato!",
  },
  create_weblink_error: {
    EN: "Error when creating weblink!",
    FR: "Erreur lors de la création du lien web !",
    IT: "Errore durante la creazione del collegamento web!",
  },
  update_weblink: {
    EN: "Weblink updated!",
    FR: "Le lien web a été mis à jour !",
    IT: "Collegamento web aggiornato!",
  },
  update_weblink_error: {
    EN: "Error when updating weblink!",
    FR: "Erreur lors de la mise à jour du lien web !",
    IT: "Errore durante l'aggiornamento del collegamento web!",
  },
  delete_weblink: {
    EN: "Weblink deleted!",
    FR: "Le lien web a été supprimé !",
    IT: "Collegamento web eliminato!",
  },
  missing_user: {
    EN: "Authenticated user data is missing, refresh the page!",
    FR: "Il manque des données utilisateur authentifiées, actualisez la page !",
    IT: "I dati utente autenticati mancano, aggiorna la pagina!",
  },
  missing_room: {
    EN: "Room data is missing, refresh the page!",
    FR: "Il manque des données de pièce, actualisez la page !",
    IT: "I dati della stanza mancano, aggiorna la pagina!",
  },
  update_error: {
    EN: "Whoops, something went wrong, try again!",
    FR: "Oups, quelque chose s'est mal passé, veuillez réessayer !",
    IT: "Ops, qualcosa è andato storto, riprova!",
  },
  create_error: {
    EN: "Whoops, something went wrong, try again!",
    FR: "Oups, quelque chose s'est mal passé, veuillez réessayer !",
    IT: "Ops, qualcosa è andato storto, riprova!",
  },
  missing_request_option_template: {
    EN: "Request option template data is missing, refresh the page!",
    FR: "Il manque des données de modèle d'option de requête, actualisez la page !",
    IT: "I dati del modello di opzione di richiesta mancano, aggiorna la pagina!",
  },
  missing_request_options: {
    EN: "Missing request options",
    FR: "Options de demande manquantes",
    IT: "Opzioni di richiesta mancanti",
  },
  delete_success: {
    EN: "Successfully deleted!",
    FR: "Supprimé avec succès !",
    IT: "Eliminato con successo!",
  },
  delete_error: {
    EN: "Whoops, something went wrong, try again!",
    FR: "Oups, quelque chose s'est mal passé, veuillez réessayer !",
    IT: "Ops, qualcosa è andato storto, riprova!",
  },
  missing_device: {
    EN: "Device data is missing, refresh the page!",
    FR: "Il manque des données de l'appareil, actualisez la page !",
    IT: "I dati del dispositivo mancano, aggiorna la pagina!",
  },
  missing_name: {
    EN: "Name is missing!",
    FR: "Le nom est manquant !",
    IT: "Il nome manca!",
  },
  undo_log: {
    EN: "Log activity successfully undone!",
    FR: "Activité du journal annulée avec succès !",
    IT: "Attività del registro annullata con successo!",
  },
  undo_log_error: {
    EN: "Error when undoing log activity!",
    FR: "Erreur lors de l'annulation de l'activité du journal !",
    IT: "Errore durante l'annullamento dell'attività del registro!",
  },
  missing_text: {
    EN: "Text is missing!",
    FR: "Le texte est manquant !",
    IT: "Il testo manca!",
  },
  missing_tags: {
    EN: "Tags are missing!",
    FR: "Les balises sont manquantes !",
    IT: "I tag mancano!",
  },
  date_is_past: {
    EN: "The selected date is in the past, please choose a future date!",
    FR: "La date sélectionnée est dans le passé, veuillez choisir une date future !",
    IT: "La data selezionata è nel passato, scegli una data futura!",
  },
  invalid_minutes: {
    EN: "Minutes must be between 0 and 59!",
    FR: "Les minutes doivent être comprises entre 0 et 59 !",
    IT: "I minuti devono essere compresi tra 0 e 59!",
  },
  invalid_hours: {
    EN: "Hours must be between 0 and 23!",
    FR: "Les heures doivent être comprises entre 0 et 23 !",
    IT: "Le ore devono essere comprese tra 0 e 23!",
  },
  invalid_days: {
    EN: "Days must be between 1 and 31!",
    FR: "Les jours doivent être compris entre 1 et 31 !",
    IT: "I giorni devono essere compresi tra 1 e 31!",
  },
  missing_dow: {
    EN: "Days of the week are missing!",
    FR: "Les jours de la semaine sont manquants !",
    IT: "I giorni della settimana mancano!",
  },
  missing_dom: {
    EN: "Days of the month are missing!",
    FR: "Les jours du mois sont manquants !",
    IT: "I giorni del mese mancano!",
  },
  missing_date: {
    EN: "Date is missing!",
    FR: "La date est manquante !",
    IT: "La data manca!",
  },
  missing_contact_book: {
    EN: "Contact book is missing!",
    FR: "Le carnet d'adresses est manquant !",
    IT: "La rubrica manca!",
  },
  update_room_calling: {
    EN: "Calling contacts for rooms updated!",
    FR: "Appel des contacts pour les pièces mis à jour !",
    IT: "Chiamata dei contatti per le stanze aggiornata!",
  },
  update_reciprocal_associations: {
    EN: "Reciprocal associations updated!",
    FR: "Associations réciproques mises à jour !",
    IT: "Associazioni reciproche aggiornate!",
  },
  missing_communication_profile: {
    EN: "Communication profile is missing!",
    FR: "Le profil de communication est manquant !",
    IT: "Il profilo di comunicazione manca!",
  },
  missing_campaign: {
    EN: "Campaign is missing!",
    FR: "La campagne est manquante !",
    IT: "La campagna manca!",
  },
  missing_description: {
    EN: "Description is missing!",
    FR: "La description est manquante !",
    IT: "La descrizione manca!",
  },
  missing_header: {
    EN: "Header is missing!",
    FR: "L'en-tête est manquant !",
    IT: "L'intestazione manca!",
  },
  missing_primary_text: {
    EN: "Primary text is missing!",
    FR: "Le texte principal est manquant !",
    IT: "Il testo principale manca!",
  },
  missing_secondary_text: {
    EN: "Secondary text is missing!",
    FR: "Le texte secondaire est manquant !",
    IT: "Il testo secondario manca!",
  },
  missing_body: {
    EN: "Body is missing!",
    FR: "Le corps est manquant !",
    IT: "Il corpo manca!",
  },
  missing_title: {
    EN: "Title is missing!",
    FR: "Le titre est manquant !",
    IT: "Il titolo manca!",
  },
  missing_background_image: {
    EN: "Background image is missing!",
    FR: "L'image de fond est manquante !",
    IT: "L'immagine di sfondo manca!",
  },
  missing_start_date: {
    EN: "Start date is missing!",
    FR: "La date de début est manquante !",
    IT: "La data di inizio manca!",
  },
  missing_end_date: {
    EN: "End date is missing!",
    FR: "La date de fin est manquante !",
    IT: "La data di fine manca!",
  },
  missing_rooms: {
    EN: "Rooms are missing!",
    FR: "Les pièces sont manquantes !",
    IT: "Le stanze mancano!",
  },
  start_before_now: {
    EN: "Start date must be after the current date!",
    FR: "La date de début doit être postérieure à la date actuelle !",
    IT: "La data di inizio deve essere successiva alla data attuale!",
  },
  missing_start_time: {
    EN: "Start time is missing!",
    FR: "L'heure de début est manquante !",
    IT: "L'ora di inizio manca!",
  },
  missing_end_time: {
    EN: "End time is missing!",
    FR: "L'heure de fin est manquante !",
    IT: "L'ora di fine manca!",
  },
  start_after_end: {
    EN: "Start datetime must be before end datetime!",
    FR: "La date et l'heure de début doivent être antérieures à la date et à l'heure de fin !",
    IT: "La data e l'ora di inizio devono essere precedenti alla data e all'ora di fine!",
  },
  missing_days_of_the_week: {
    EN: "Days of the week are missing!",
    FR: "Les jours de la semaine sont manquants !",
    IT: "I giorni della settimana mancano!",
  },
  missing_days_of_the_month: {
    EN: "Days of the month are missing!",
    FR: "Les jours du mois sont manquants !",
    IT: "I giorni del mese mancano!",
  },
  create_campaign: {
    EN: "Campaign created!",
    FR: "Campagne créée !",
    IT: "Campagna creata!",
  },
  missing_start_datetime: {
    EN: "Start datetime is missing!",
    FR: "La date et l'heure de début sont manquantes !",
    IT: "La data e l'ora di inizio mancano!",
  },
  missing_end_datetime: {
    EN: "End datetime is missing!",
    FR: "La date et l'heure de fin sont manquantes !",
    IT: "La data e l'ora di fine mancano!",
  },
  missing_recurring_schedule_detail: {
    EN: "Missing start or end time details for recurring values!",
    FR: "Détails de l'heure de début ou de fin manquants pour les valeurs récurrentes !",
    IT: "Dettagli dell'ora di inizio o di fine mancanti per i valori ricorrenti!",
  },
  missing_selected_days: {
    EN: "There are no dates selected!",
    FR: "Aucune date sélectionnée !",
    IT: "Non ci sono date selezionate!",
  },
  missing_events: {
    EN: "Events are missing!",
    FR: "Les événements sont manquants !",
    IT: "Gli eventi mancano!",
  },
  missing_services: {
    EN: "Services are missing!",
    FR: "Les services sont manquants !",
    IT: "I servizi mancano!",
  },
  missing_category: {
    EN: "Category is missing!",
    FR: "La catégorie est manquante !",
    IT: "La categoria manca!",
  },
  missing_availability: {
    EN: "Availability is missing!",
    FR: "La disponibilité est manquante !",
    IT: "La disponibilità manca!",
  },
  missing_items: {
    EN: "Items are missing!",
    FR: "Les articles sont manquants !",
    IT: "Gli articoli mancano!",
  },
  missing_menus: {
    EN: "Menus are missing!",
    FR: "Les menus sont manquants !",
    IT: "I menu mancano!",
  },
  missing_newsletters: {
    EN: "Newsletters are missing!",
    FR: "Les newsletters sont manquantes !",
    IT: "Le newsletter mancano!",
  },
  missing_sections: {
    EN: "Sections are missing!",
    FR: "Les sections sont manquantes !",
    IT: "Le sezioni mancano!",
  },
  section_position_incorrect: {
    EN: "Section position is incorrect!",
    FR: "La position de la section est incorrecte !",
    IT: "La posizione della sezione è errata!",
  },
  max_uploads_reached: {
    EN: "You've reached the maximum number of uploads!",
    FR: "Vous avez atteint le nombre maximum de téléchargements !",
    IT: "Hai raggiunto il numero massimo di caricamenti!",
  },
  process_file_error: {
    EN: "Error when processing file, try again!",
    FR: "Erreur lors du traitement du fichier, réessayez !",
    IT: "Errore durante l'elaborazione del file, riprova!",
  },
  missing_image: {
    EN: "Image is missing!",
    FR: "L'image est manquante !",
    IT: "L'immagine manca!",
  },
  missing_url: {
    EN: "URL is missing!",
    FR: "L'URL est manquante !",
    IT: "L'URL manca!",
  },
  missing_weblinks: {
    EN: "Weblinks are missing!",
    FR: "Les liens web sont manquants !",
    IT: "I collegamenti web mancano!",
  },
  missing_trivia: {
    EN: "Trivia are missing!",
    FR: "Les anecdotes sont manquantes !",
    IT: "Le curiosità mancano!",
  },
  missing_survey: {
    EN: "Survey is missing!",
    FR: "Le sondage est manquant !",
    IT: "Il sondaggio manca!",
  },
  missing_surveys: {
    EN: "Surveys are missing!",
    FR: "Les sondages sont manquants !",
    IT: "I sondaggi mancano!",
  },
  missing_pois: {
    EN: "Points of interest are missing!",
    FR: "Les points d'intérêt sont manquants !",
    IT: "I punti di interesse mancano!",
  },
  missing_poi: {
    EN: "Point of interest is missing!",
    FR: "Le point d'intérêt est manquant !",
    IT: "Il punto di interesse manca!",
  },
  update_global_directions: {
    EN: "Global directions updated!",
    FR: "Les instructions globales ont été mises à jour !",
    IT: "Indicazioni globali aggiornate!",
  },
  create_global_directions: {
    EN: "Global directions created!",
    FR: "Les instructions globales ont été créées !",
    IT: "Indicazioni globali create!",
  },
  updated_local_directions: {
    EN: "Local directions updated!",
    FR: "Les instructions locales ont été mises à jour !",
    IT: "Indicazioni locali aggiornate!",
  },
  missing_webhooks: {
    EN: "Webhooks are missing!",
    FR: "Les webhooks sont manquants !",
    IT: "I webhook mancano!",
  },
  update_appliance_power: {
    EN: "Appliance power updated!",
    FR: "L'alimentation de l'appareil a été mise à jour !",
    IT: "L'alimentazione dell'elettrodomestico è stata aggiornata!",
  },
  update_appliance_forget: {
    EN: "Appliance forgetten!",
    FR: "L'appareil a été oublié !",
    IT: "L'elettrodomestico è stato dimenticato!",
  },
  missing_groups: {
    EN: "Groups are missing!",
    FR: "Les groupes sont manquants !",
    IT: "I gruppi mancano!",
  },
  create_group: {
    EN: "Group created!",
    FR: "Le groupe a été créé !",
    IT: "Gruppo creato!",
  },
  update_group: {
    EN: "Group updated!",
    FR: "Le groupe a été mis à jour !",
    IT: "Gruppo aggiornato!",
  },
  update_request_options_status: {
    EN: "Request options status updated!",
    FR: "Le statut des options de demande a été mis à jour !",
    IT: "Stato delle opzioni di richiesta aggiornato!",
  },
  missing_current_password: {
    EN: "Current password is missing!",
    FR: "Le mot de passe actuel est manquant !",
    IT: "La password attuale manca!",
  },
  missing_new_password: {
    EN: "New password is missing!",
    FR: "Le nouveau mot de passe est manquant !",
    IT: "La nuova password manca!",
  },
  missing_confirm_new_password: {
    EN: "Confirm new password is missing!",
    FR: "Confirmer le nouveau mot de passe est manquant !",
    IT: "Conferma la nuova password manca!",
  },
  same_passwords: {
    EN: "New password must be different from current password!",
    FR: "Le nouveau mot de passe doit être différent du mot de passe actuel !",
    IT: "La nuova password deve essere diversa dalla password attuale!",
  },
  different_passwords: {
    EN: "New password and confirm new password must match!",
    FR: "Le nouveau mot de passe et la confirmation du nouveau mot de passe doivent correspondre !",
    IT: "La nuova password e la conferma della nuova password devono corrispondere!",
  },
  missing_request_option: {
    EN: "Request option is missing!",
    FR: "L'option de demande est manquante !",
    IT: "L'opzione di richiesta manca!",
  },
  missing_price: {
    EN: "Price is missing!",
    FR: "Le prix est manquant !",
    IT: "Il prezzo manca!",
  },
  missing_tax_percentage: {
    EN: "Tax percentage is missing!",
    FR: "Le pourcentage de taxe est manquant !",
    IT: "La percentuale di tasse manca!",
  },
  missing_payment_items: {
    EN: "Payment items are missing!",
    FR: "Les éléments de paiement sont manquants !",
    IT: "Gli elementi di pagamento mancano!",
  },
  create_task: {
    EN: "Task created!",
    FR: "La tâche a été créée !",
    IT: "Attività creata!",
  },
  update_task: {
    EN: "Task updated!",
    FR: "La tâche a été mise à jour !",
    IT: "Attività aggiornata!",
  },
  missing_tasks: {
    EN: "Tasks are missing!",
    FR: "Les tâches sont manquantes !",
    IT: "Le attività mancano!",
  },
  update_task_log: {
    EN: "Task log updated!",
    FR: "Le journal des tâches a été mis à jour !",
    IT: "Registro attività aggiornato!",
  },
  create_prompt: {
    EN: "Prompt created!",
    FR: "Le message a été créé !",
    IT: "Prompt creato!",
  },
  update_prompt: {
    EN: "Prompt updated!",
    FR: "Le message a été mis à jour !",
    IT: "Prompt aggiornato!",
  },
  missing_prompts: {
    EN: "Prompts are missing!",
    FR: "Les messages sont manquants !",
    IT: "Prompt mancano!",
  },
  redirecting: {
    EN: "Redirecting...",
    FR: "Redirection...",
    IT: "Reindirizzamento...",
  },
  payment_pin_fail: {
    EN: "Payment PIN was incorrect! Try again.",
    FR: "Le NIP de paiement était incorrect ! Réessayez.",
    IT: "Il PIN di pagamento era errato! Riprova.",
  },
};

const defaultError: any = {
  EN: "Error!",
  FR: "Veuillez !",
  IT: "Errore!",
};

export function generateAlertText(action: string, language: string) {
  if (action in lookup) {
    const text = lookup[action][language];
    return text;
  }
  return defaultError[language];
}
